import 'css-chunksrc/client/scenes/wbs/task/allocationsList/details/spentHours/styles.scss';export default {
  "spentHours": "_spentHours_5pcqp_1",
  "text": "_text_5pcqp_7"
};